import { Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, NgForm, UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ValidateUUID } from 'app/helpers/validators';
import { ExposedCreateMortgageEligibilityInfoReq } from 'app/interfaces/requests/Exposed/exposedCreateMortgageEligibilityInfoReq';
import { Option } from 'app/interfaces/support/option';
import { MortgageEligibilityInfoService } from 'app/services/api/mortgageEligibilityInfo/mortgageEligibilitInfo.service';
import { ORIGINATING_SYSTEMS } from 'common/constants/mortgage-eligibility-originating-systems.constants';
import { UUIDRegex } from 'common/constants/regex.constants';
import { DialogGeneral } from '../../../DialogGeneral';

export interface DialogEditUserAddData {}

@Component({
    selector: 'dialog-mortgage-eligibility-create',
    templateUrl: 'dialog-mortgage-eligibility-create.html',
    styleUrls: ['dialog-mortgage-eligibility-create.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogMortgageEligibilityCreateComponent extends DialogGeneral {
    @ViewChild('ngForm') ngForm: NgForm;
    form: FormGroup;
    formEnabled = true;
    systemOptions: Option<string>[];
    checkingIfExternalServiceIdExists: boolean = false;
    existsingExternalServiceId: number;
    showOriginatingSystemApplicationIdInput: boolean = false;

    /**
     * Constructor
     */
    constructor(
        public matDialogRef: MatDialogRef<DialogMortgageEligibilityCreateComponent>,
        private formBuilder: UntypedFormBuilder,
        private mortgageEligibilityInfoService: MortgageEligibilityInfoService,
        public dialogRef: MatDialogRef<null>,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: DialogEditUserAddData
    ) {
        super(dialogRef);
        this.fetchOriginatingSystemOptions();
        this.initForm();
    }

    initForm = () => {
        this.form = this.formBuilder.group({
            externalServiceId: new FormControl('', [Validators.required, ValidateUUID]),
            originatingSystemApplicationId: new FormControl(''),
            originatingSystem: new FormControl('', Validators.required),
        });

        this.form.controls['externalServiceId'].valueChanges.subscribe((val) => {
            if (val.length == 36 && UUIDRegex.test(val)) {
                this.checkingIfExternalServiceIdExists = true;
                this.existsingExternalServiceId = null;
                this.mortgageEligibilityInfoService
                    .getMortgageEligibilityInfoExists(val)
                    .then((res) => {
                        this.existsingExternalServiceId = res.id;
                    })
                    .catch((err) => {
                        this.existsingExternalServiceId = null;
                    })
                    .finally(() => {
                        this.checkingIfExternalServiceIdExists = false;
                    });
            } else {
                this.existsingExternalServiceId = null;
                this.checkingIfExternalServiceIdExists = false;
            }
        });

        this.form.controls['originatingSystem'].valueChanges.subscribe((val) => {
            this.showOriginatingSystemApplicationIdInput = val != ORIGINATING_SYSTEMS.Libra;

            if (this.showOriginatingSystemApplicationIdInput) {
                this.form.controls['originatingSystemApplicationId'].addValidators(Validators.required);
            } else {
                this.form.controls['originatingSystemApplicationId'].reset('');
                this.form.controls['originatingSystemApplicationId'].clearValidators();
                this.form.controls['originatingSystemApplicationId'].updateValueAndValidity();
            }
        });
    };

    fetchOriginatingSystemOptions = () => {
        this.mortgageEligibilityInfoService.getMortgageEligibilityInfoOriginatingSystems().subscribe((res: Option<string>[]) => {
            this.systemOptions = res;
        });
    };

    openExistingDocument = () => {
        this.dialogRef.close(this.existsingExternalServiceId);
    };

    submit = () => {
        if (!this.form.valid) {
            return;
        }
        this.formEnabled = false;
        let req = {
            externalServiceId: this.form.get('externalServiceId').value,
            originatingSystemApplicationId: this.form.get('originatingSystemApplicationId').value,
            originatingSystem: this.form.get('originatingSystem').value,
        } as ExposedCreateMortgageEligibilityInfoReq;

        this.mortgageEligibilityInfoService.createMortgageEligibilityInfo(req).subscribe((id: number) => {
            if (id) {
                this.dialogRef.close(id);
            } else {
                this.formEnabled = true;
                this.form.enable();
            }
        });
    };
}
